export class SortResourceBy {
    'field';
    'order';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "field",
            "baseName": "field",
            "type": "ResourceSortField",
            "format": ""
        },
        {
            "name": "order",
            "baseName": "order",
            "type": "SortOrder",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SortResourceBy.attributeTypeMap;
    }
    constructor() {
    }
}
